"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.CreditsUsageWrapper = exports.CreditCountSkeleton = void 0;
var _reactLoadingSkeleton = _interopRequireDefault(require("react-loading-skeleton"));
var _styledComponents = _interopRequireDefault(require("styled-components"));
const CreditsUsageWrapper = exports.CreditsUsageWrapper = _styledComponents.default.div.withConfig({
  displayName: "CreditsUsagestyle__CreditsUsageWrapper",
  componentId: "sc-q5ipph-0"
})(["display:flex;position:relative;align-items:center;background:transparent;text-decoration:none;height:22px;border-radius:2px;padding:0 8px;color:white;& > span{line-height:20px;white-space:pre}& > div{white-space:pre}"]);
const CreditCountSkeleton = exports.CreditCountSkeleton = (0, _styledComponents.default)(_reactLoadingSkeleton.default).withConfig({
  displayName: "CreditsUsagestyle__CreditCountSkeleton",
  componentId: "sc-q5ipph-1"
})(["margin-left:10px;"]);